// export const BaseUrl = "https://asia-southeast2-vserv-383708.cloudfunctions.net/api2";
export const BaseUrl = "https://asia-southeast2-vserv-383708.cloudfunctions.net/prod";
export const BaseUrlPHP = "https://sys.vservtechnology.com/api";
// export const BaseUrl = "http://127.0.0.1:5001/vserv-383708/asia-southeast2/prod";
// export const BaseUrl = "https://asia-southeast2-vserv-383708.cloudfunctions.net/test";





